import { Component, OnInit, Renderer2, ElementRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject, takeUntil } from 'rxjs';
import { IOHAppService } from 'src/app/services/ioh-app.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'ioh-level-one-svg',
  template: `<div #iohsvgContainer class="ioh-svg-one-container"></div>`,
  styles: [
    `
      .ioh-svg-one-container {
        width: 100%;
        height: 100%;
        position: relative;
      }
      .ioh-svg-one-container svg {
        width: 100%;
        height: 100%;
      }
    `
  ]
})
export class IOHLevelOneSvgComponent implements OnInit {
  terminalElements: Element[] = [];
  terminalElementsMap: any = {};

  constructor(
    private http: HttpClient,
    private renderer: Renderer2,
    private el: ElementRef,
    private iohAppService: IOHAppService
  ) {}

  private destroy$ = new Subject<void>();

  ngOnInit() {
    this.loadSvg();
  }

  //method to load level 1 svg
  loadSvg() {
    const svgVersion = environment.appConfig.svgVersion;
    this.http
      .get(`/assets/ioh/svg/IOH_Level_1.svg?version=${svgVersion}`, {
        responseType: 'text'
      })
      .pipe(takeUntil(this.destroy$))
      .subscribe(svgContent => {
        const parser = new DOMParser();
        const svg = parser
          .parseFromString(svgContent, 'image/svg+xml')
          .querySelector('svg');

        if (svg) {
          const iohsvgContainer = this.el.nativeElement.querySelector(
            '.ioh-svg-one-container'
          );
          this.renderer.appendChild(iohsvgContainer, svg);
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
